import { useQuery } from '@tanstack/react-query';
import { merchantService } from 'commons/services';

export function useInstallation() {
  return useQuery(['installation'], () => merchantService.getInstallation());
}
